

































import { defineComponent, onMounted, ref } from "@vue/composition-api";
import { QBtn } from "quasar";
import router from "@/router";

export default defineComponent({
  components: {
    QBtn,
  },
  props: {
    branding: Object,
    clientKey: String,
  },
  setup() {
    const showReadMore = ref(false);
    const expanded = ref(false);
    const app = router.currentRoute.query.app
      ? `&app=${router.currentRoute.query.app}`
      : "";
    const toggleExpanded = () => (expanded.value = !expanded.value);

    onMounted(() => {
      const element = document.getElementById("brandingTextContent");
      // console.log(element!.offsetHeight, element!.scrollHeight);
      if (element === null) return;
      if (element!.offsetHeight < element!.scrollHeight) {
        showReadMore.value = true;
      }
    });

    return { expanded, toggleExpanded, app, showReadMore };
  },
});
